import React from 'react'
import { LogisticStatus as LogisticStatusEntries } from '@ztechapps/logistic.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

export type LogisticStatusProps = { status: string }

export const LogisticStatusBadge = ({ status }: LogisticStatusProps) => (
  <StatusColorBadge status={status} color={findStatus(LogisticStatusEntries, status)} />
)

export const LogisticStatus = ({ status }: LogisticStatusProps) => (
  <StatusColorDot value={status} color={findStatus(LogisticStatusEntries, status)} />
)
